import { render, staticRenderFns } from "./relatorioResumo.vue?vue&type=template&id=4ddefb1c"
import script from "./relatorioResumo.vue?vue&type=script&lang=js"
export * from "./relatorioResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports